export {
  HorizontalSeparator,
  VerticalSeparator,
  BulletSeparator,
  A11yDashSeparator,
} from './separator';
